// extracted by mini-css-extract-plugin
export default {"container":"UploadProgress_container__MlCCa","progress":"UploadProgress_progress__h8Ef0","top":"UploadProgress_top__TVTly","text":"UploadProgress_text__ksnzN"};